import { useTranslation } from "react-i18next";
import {
  useAddBanMutation,
  useRemoveBanMutation,
  useBannedQuery,
} from "../Teams.state";
import { CardBody } from "../../App.styles";
import TeamSelect from "../TeamSelect";
import Spinner from "../../common/Spinner";

const Banned = () => {
  const { t } = useTranslation();
  const { addBan } = useAddBanMutation();
  const { removeBan } = useRemoveBanMutation();
  const { data: banned, isFetching } = useBannedQuery();
  const handleChange = async (value) => {
    for (let player of value.filter(
      (v) => !banned.find((b) => b.id === v.id)
    )) {
      await addBan(player);
    }

    for (let player of banned.filter(
      (b) => !value.find((v) => v.id === b.id)
    )) {
      await removeBan(player);
    }
  };

  return (
    <CardBody className="card">
      <div className="card-header bg-dark text-light">
        <span className="card-title">{t('Banned')}</span>
      </div>
      <div className="card-body">
        <p dangerouslySetInnerHTML={{__html: t('Anyone breaking the rules? Add them here to toss them from the game.')}} />
        {
          isFetching
          ? <Spinner size="0.875rem" />
          : (
            <TeamSelect
              setValue={handleChange}
              value={banned}
              mapLabel="email"
              placeholder={t("Select people...")}
            />
          )
        }
      </div>
    </CardBody>
  );
};

export default Banned;
